'use strict';
var React = require('react');
var ReactDOM = require('react-dom');

var QrCode = React.createClass({
    propTypes: {
        URL: React.PropTypes.string.isRequired,
        width: React.PropTypes.number.isRequired,
        height: React.PropTypes.number.isRequired,
        hide: React.PropTypes.bool
    },
    getInitialState: function () {
        /*二维码默认显示*/
        return {
            showQRCode: true
        };
    },
    componentDidMount: function () {
        var element = ReactDOM.findDOMNode(this.refs.code);
        new QRCode(element, {
            text: this.props.URL,
            width: this.props.width,
            height: this.props.height
        });
    },
    render: function () {
        var style;
        style = {
            width: this.props.width + 10,
            height: this.props.height + 10,
            padding: 5,
            display: 'inline-block',
            boxSizing: 'border-box',
            background: '#fff'
        };
        if (this.props.hide) {
            style.display = 'none';
        }
        return (
            <div className="qr-code" style={style}>
                <div ref="code"></div>
            </div>
        );
    }
});

module.exports = QrCode;


// WEBPACK FOOTER //
// ./src/views/QrCode.jsx